export default __webpack_public_path__ + "static/media/reload_order_no.767dfe7d.svg";